export default __webpack_public_path__ + "static/media/logo.b219e203.svg";